var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderFood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.42 15.4114H3.00063C3.00063 15.4114 4.79612 31.3216 5.39292 36.6123C5.50143 37.5736 6.3144 38.3001 7.28166 38.3001C10.7607 38.3001 18.6599 38.3001 22.1381 38.3001C23.1062 38.3001 23.9192 37.5736 24.0277 36.6123C24.6245 31.3216 26.42 15.4114 26.42 15.4114Z",
    stroke: "#FF4C29",
    strokeWidth: 1.7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4207 12.246C28.4207 11.7416 28.2198 11.2575 27.8637 10.9015C27.5068 10.5446 27.0236 10.3445 26.5192 10.3445C21.4981 10.3445 7.92256 10.3445 2.90146 10.3445C2.39706 10.3445 1.91301 10.5446 1.55696 10.9015C1.20006 11.2575 1 11.7416 1 12.246C1 12.6588 1 13.0971 1 13.51C1 14.0144 1.20006 14.4984 1.55696 14.8545C1.91301 15.2113 2.39706 15.4114 2.90146 15.4114C7.92256 15.4114 21.4981 15.4114 26.5192 15.4114C27.0236 15.4114 27.5068 15.2113 27.8637 14.8545C28.2198 14.4984 28.4207 14.0144 28.4207 13.51C28.4207 13.0971 28.4207 12.6588 28.4207 12.246Z",
    stroke: "#FF4C29",
    strokeWidth: 1.7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1227 10.3445H5.298V8.85083C5.298 7.80049 6.14913 6.94937 7.19946 6.94937C10.8082 6.94937 18.6125 6.94937 22.2212 6.94937C23.2716 6.94937 24.1227 7.80049 24.1227 8.85083C24.1227 9.6265 24.1227 10.3445 24.1227 10.3445Z",
    stroke: "#FF4C29",
    strokeWidth: 1.7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9033 22.2094C14.3001 24.6195 14.7917 25.1696 13.6871 28.402C13.1853 29.8711 13.3633 31.2614 13.7762 32.4092L13.6871 32.4228C11.8018 32.4228 10.2716 30.1272 10.2716 27.3C10.2716 24.4728 11.8018 22.1771 13.6871 22.1771L13.9033 22.2094Z",
    stroke: "#FF4C29",
    strokeWidth: 1.7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9489 22.1771C17.7316 22.3179 19.149 24.5457 19.149 27.2669C19.149 30.0543 17.6613 32.3253 15.8217 32.3762C15.4089 31.2284 15.2308 29.8389 15.7327 28.3698C16.8373 25.1374 16.3456 24.5872 15.9489 22.1771Z",
    stroke: "#FF4C29",
    strokeWidth: 1.7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8408 36.6047C27.8408 36.6047 35.8035 37.3897 40.5398 37.8568C42.6905 38.0695 44.6174 36.525 44.8785 34.3802C45.4795 29.365 44.3215 21.0327 30.4137 19.6619C28.8055 19.5034 27.3415 19.4686 26.008 19.539",
    stroke: "#FF4C29",
    strokeWidth: 1.7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7993 21.098C36.3563 22.1297 37.3134 24.5449 37.293 28.9386",
    stroke: "#FF4C29",
    strokeWidth: 1.7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6885 19.823C28.6885 19.823 30.5993 22.0856 30.5705 28.2757",
    stroke: "#FF4C29",
    strokeWidth: 1.7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5637 6.94937L15.4114 1L22.1932 1.84773",
    stroke: "#FF4C29",
    strokeWidth: 1.7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderFood);
export default __webpack_public_path__ + "static/media/order_food.1807e5de5b54683b6c18f1c92f78f86d.svg";
export { ForwardRef as ReactComponent };